import classNames from 'classnames';
import React from 'react';
import FeatherIcon from '../Icon/FeatherIcon';

type ModalHeaderProps = {
  title: string;
  description?: string;
  className?: string;
  onClose?: () => void;
  color?: string;
  padded?: boolean;
  size?: 'md' | 'sm';
};

const ModalHeader = ({
  title,
  description = '',
  className = '',
  onClose,
  color,
  padded = true,
  size = 'md'
}: ModalHeaderProps) => (
  <header
    className={classNames(
      'flex flex-col flex-shrink-0 w-full',
      { 'pt-6 px-6 md:pt-8 md:px-8': padded },
      className,
      { 'pb-4 md:pb-6': !description && padded }
    )}
  >
    {onClose && (
      <div className="flex self-end">
        <button type="button" onClick={onClose}>
          <FeatherIcon name="x" size={32} color={color} />
        </button>
      </div>
    )}
    {title && (
      <h3
        className={classNames('text-primary font-display mt-8', {
          'text-xl md:text-2xl font-bold': size === 'md',
          'text-lg md:text-xl': size === 'sm'
        })}
        style={{ color }}
      >
        {title}
      </h3>
    )}
    {description && (
      <p className="text-sm text-gray-600 font-body whitespace-pre-wrap mb-6">
        {description}
      </p>
    )}
  </header>
);

export default ModalHeader;
